import type { PageContext } from 'src/components/common/page-context';
import { DEFAULT_CLUB_ID } from 'src/content/constants';
import type { SiteConfig } from 'src/context/site-context';
import { getBuildTypesFlags } from 'src/context/site-context-helper';
import { getStyling } from 'src/context/styling';
import { languageFromCurrentUrlOrBuildTypeDefault } from 'src/helpers/language-helper';

export const pageContextToSiteConfig = (
  pageContext: PageContext,
  is404Page: boolean
): SiteConfig => {
  const pageLevel =
    pageContext.pageLayout && 'pageLevel' in pageContext.pageLayout
      ? pageContext.pageLayout.pageLevel
      : undefined;
  return {
    siteId: pageContext.clubId || DEFAULT_CLUB_ID,
    isGlobalPage: pageContext.isGlobalPage,
    language: is404Page
      ? languageFromCurrentUrlOrBuildTypeDefault(pageContext.buildType)
      : pageContext.language,
    pageLanguages: pageContext.pageLanguages,
    alternatePages: pageContext.alternatePages ?? [],
    buildType: pageContext.buildType,
    ...getBuildTypesFlags(pageContext.buildType),
    styling: getStyling(pageContext.buildType),
    inlineImageData: pageContext.inlineImageData,
    basePath: pageContext.basePath,
    untranslatedPath: pageContext.untranslatedPath,
    pageLevel,
    seo: pageContext.seo,
  };
};
